import {
  ADD_ATTRIBUTES,
  ADD_DIMENSION,
  ADD_FACT_TABLE,
  ADD_LINK,
  ADD_REASON,
  DELETE_ATTRIBUTE,
  DELETE_DIMENSION,
  DELETE_FACT,
  DELETE_LINK,
  DELETE_MEASURE,
  HIDE_ATTRIBUTES_MODAL,
  HIDE_DIMENSION_MODAL,
  HIDE_FACT_MODAL,
  HIDE_LINK_MODAL,
  HIDE_MEASURES_MODAL,
  HIDE_OPTIONS_MODAL,
  HIDE_SLIDER_MODAL,
  HIDE_TAGS_MODAL,
  LOAD_REMOVE_MODAL,
  RESET_ATTRIBUTES_MODAL,
  RESET_DIMENSION_MODAL,
  RESET_FACT_MODAL,
  RESET_REASONS_MODAL,
  SET_AGGREGATION_TYPES,
  SET_ATTRIBUTES_MODAL_LOADING,
  SET_CONFIRM_MODAL,
  SET_DATA,
  SET_DATA_TYPES,
  SET_DIMENSION_MODAL_LOADING,
  SET_FACT_MODAL_LOADING,
  SET_FILTER,
  SET_LINK_DIMENSION,
  SET_LINK_FACT,
  SET_LINK_MODAL_LOADING,
  SET_MEASURES_MODAL_LOADING,
  SET_ORIGINAL_DATA,
  SET_REMOVE_ITEMS_MODAL,
  SET_SHOW_HIDE_ATTRIBUTES,
  SET_SHOW_HIDE_MINOR_ELEMENTS,
  SET_SUN_MODEL_LOADING, SET_TAGS, SET_TAGS_LOADING,
  SHOW_ATTRIBUTES_MODAL,
  SHOW_DIMENSION_MODAL,
  SHOW_FACT_MODAL,
  SHOW_LINK_MODAL,
  SHOW_MEASURES_MODAL,
  SHOW_OPTIONS_MODAL,
  SHOW_SLIDER_MODAL,
  SHOW_TAGS_MODAL,
  UNLOAD_DATA,
  UPDATE_ATTRIBUTES,
  UPDATE_DIMENSION,
  UPDATE_FACT_TABLE,
} from './mutation-types';

export default {
  /**
   *
   * @param { SunModelState } state
   * @param { object } data
   */
  [SET_FILTER](state, {data}) {
    state.sunModel.optionsFilter = {...state.sunModel.optionsFilter, ...data};

  },


  /**
   *
   * @param { SunModelState } state
   * @param { object } data
   */
  [SET_ORIGINAL_DATA](state, data) {
    state.sunModel.loaded = true;
    state.sunModel.originalData = {...data};
  },


  /**
   *
   * @param { SunModelState } state
   * @param { object } data
   */
  [SET_DATA](state, data) {
    state.sunModel.loaded = true;
    state.sunModel.data = {...data};
  },
  [UNLOAD_DATA](state) {
    state.sunModel.loaded = false;
    state.sunModel.data = {
      facts: [],
      dimensions: [],
      links: [],
    };
    state.sunModel.originalData = {
      facts: [],
      dimensions: [],
      links: [],
    };
  },
  /**
   *
   * @param { SunModelState } state
   * @param { object } data
   */
  [ADD_FACT_TABLE](state, data) {
    //need to change object reference to trigger watch on frontend
    const newData = {...state.sunModel.originalData};
    newData.facts.push(data);
    state.sunModel.originalData = newData;
    // state.sunModel.data.facts.push(data);
  },

  [UPDATE_FACT_TABLE](state, data) {
    const index = state.sunModel.originalData.facts.findIndex(f => f.entityId === data.entityId);
    state.sunModel.originalData.facts[index] = data;
    state.sunModel.originalData.facts = [...state.sunModel.originalData.facts];
  },


  /**
   *
   * @param { SunModelState } state
   * @param { string } data
   */
  [ADD_REASON](state, {data}) {
    const newData = {...state.sunModel.originalData};
    const index = newData.facts.findIndex((elem) => elem.name === state.measuresModal.factName);

    if (index > -1) {
      newData.facts[index].measures.push(data);
    }
    state.sunModel.originalData = newData;

  },


  /**
   *
   * @param { SunModelState } state
   * @param { string } data
   */
  [ADD_ATTRIBUTES](state, data) {
    const newData = {...state.sunModel.originalData};
    const dimIndex = newData.dimensions.findIndex((elem) => elem.entityId === state.attributesModal.entityId);
    const factIndex = newData.facts.findIndex((elem) => elem.entityId === state.attributesModal.entityId);

    if (dimIndex > -1) {
      newData.dimensions[dimIndex].attributes.push(data);
    }
    if (factIndex > -1) {
      newData.facts[factIndex].attributes.push(data);
    }
    state.sunModel.originalData = newData;

  },

  [UPDATE_ATTRIBUTES](state, data) {
    const newData = {...state.sunModel.originalData};
    const dimIndex = newData.dimensions.findIndex((elem) => elem.entityId === state.attributesModal.entityId);
    const factIndex = newData.facts.findIndex((elem) => elem.entityId === state.attributesModal.entityId);

    if (dimIndex > -1) {
      const attrIndex = newData.dimensions[dimIndex].attributes.findIndex(elem => elem.attributeId === data.attributeId);
      newData.dimensions[dimIndex].attributes[attrIndex] = data;
    }
    if (factIndex > -1) {
      const attrIndex = newData.facts[factIndex].attributes.findIndex(elem => elem.attributeId === data.attributeId);
      newData.facts[factIndex].attributes[attrIndex] = data;
    }
    state.sunModel.originalData = newData;
    state.sunModel.originalData = {...state.sunModel.originalData};
  },


  /**
   *
   * @param { SunModelState } state
   * @param { string } data
   */
  [ADD_DIMENSION](state, data) {
    //need to change object reference to trigger watch on frontend
    const newData = Object.assign({}, state.sunModel.originalData);
    newData.dimensions.push(data);
    state.sunModel.originalData = newData;

  },
  [UPDATE_DIMENSION](state, data) {
    const index = state.sunModel.originalData.dimensions.findIndex(f => f.entityId === data.entityId);
    state.sunModel.originalData.dimensions[index] = data;
    state.sunModel.originalData.dimensions = [...state.sunModel.originalData.dimensions];
  },

  /**
   *
   * @param { SunModelState } state
   * @param { string } data
   */
  [ADD_LINK](state, data) {
    //need to change object reference to trigger watch on frontend
    const newData = {...state.sunModel.originalData};
    newData.links.push(data);
    state.sunModel.originalData = newData;

    // state.sunModel.data.links.push(data);
  },

  [SET_SUN_MODEL_LOADING]: (state, loading) => state.sunModel.loading = loading,
  [SET_FACT_MODAL_LOADING]: (state, loading) => state.factModal.loading = loading,
  [SET_DIMENSION_MODAL_LOADING]: (state, loading) => state.dimensionModal.loading = loading,
  [SET_LINK_MODAL_LOADING]: (state, loading) => state.linkModal.loading = loading,
  [SHOW_FACT_MODAL]: (state, data) => {
    state.factModal.show = true;
    state.factModal.data = data ? {...data} : {...state.factModal.defaultData};
  },
  [SHOW_DIMENSION_MODAL]: (state, data) => {
    state.dimensionModal.show = true;
    state.dimensionModal.data = data ? {...data} : {...state.dimensionModal.defaultData};
  },
  [SHOW_OPTIONS_MODAL]: state => state.optionsModal.show = true,
  [HIDE_OPTIONS_MODAL]: state => state.optionsModal.show = false,
  [SHOW_LINK_MODAL]: (state, data) => {
    state.linkModal.show = true;
    state.linkModal.data = data ? {...data} : {...state.linkModal.data};
  },
  [HIDE_FACT_MODAL]: state => state.factModal.show = false,
  [HIDE_DIMENSION_MODAL]: (state, data) => {
    state.dimensionModal.show = false;
    state.dimensionModal.factName = null;

  },
  [HIDE_LINK_MODAL]: (state) => {
    state.linkModal.show = false;
    state.linkModal.data = {
      fromEntityId: '',
      toEntityId: '',
    };
  },
  [HIDE_MEASURES_MODAL]: state => {
    state.measuresModal.show = false;
    state.measuresModal.factName = null;
  },
  [SHOW_MEASURES_MODAL]: (state, data) => {
    state.measuresModal.factName = data.fact;
    state.measuresModal.show = true;

  },
  [SET_MEASURES_MODAL_LOADING]: (state, loading) => state.measuresModal.loading = loading,
  [HIDE_ATTRIBUTES_MODAL]: state => {
    state.attributesModal.show = false;
    state.attributesModal.entityId = '';
    state.attributesModal.entityType = '';
  },
  [SHOW_ATTRIBUTES_MODAL]: (state, data) => {
    state.attributesModal.show = true;
    state.attributesModal.entityId = data.entityId;
    state.attributesModal.entityType = data.entityType;
    state.attributesModal.data = data.data ? {...data.data} : {...state.attributesModal.defaultData};
  },
  [SET_ATTRIBUTES_MODAL_LOADING]: (state, loading) => state.attributesModal.loading = loading,

  [RESET_REASONS_MODAL](state) {
    state.measuresModal.data = {
      uuid: null,
      name: null,
      notes: null,
      tags: null,
      minorElement: false,
      includeOnPhysicalModel: true,
      includeOnLogicalModel: true,
      dataType: null,
      numericPrecision: null,
      scalePrecision: null,
      defaultValue: null,
      aggregationType: null,
    };
  },

  [RESET_ATTRIBUTES_MODAL](state) {
    state.attributesModal.data = {...state.attributesModal.defaultData};
  },

  /**
   * @param { SunModelState } state
   */
  [RESET_DIMENSION_MODAL](state) {
    state.dimensionModal.linkFact = null;
    state.dimensionModal.data = {...state.dimensionModal.defaultData};
  },

  /**
   * @param { SunModelState } state
   */
  [RESET_FACT_MODAL](state) {
    state.factModal.linkDimension = null;
    state.factModal.data = {...state.factModal.defaultData};
  },


  /**
   * @param { SunModelState } state
   * @param { string } data
   */
  [SET_LINK_DIMENSION](state, {data}) {
    state.factModal.linkDimension = data;
  },

  /**
   * @param { SunModelState } state
   * @param { string } data
   */
  [SET_LINK_FACT](state, data) {
    state.dimensionModal.linkFact = data;
  },

  /**
   * @param { SunModelState } state
   * @param { string } attributeId
   */
  [DELETE_ATTRIBUTE](state, attributeId) {
    const newData = {...state.sunModel.originalData};
    newData.dimensions = newData.dimensions.map((dimension) => {
      dimension.attributes = dimension.attributes.filter((attribute) => attribute.attributeId !== attributeId);
      return dimension;
    });
    newData.facts = newData.facts.map((fact) => {
      fact.attributes = fact.attributes.filter((attribute) => attribute.attributeId !== attributeId);
      return fact;
    });

    state.sunModel.originalData = newData;
  },

  /**
   * @param { SunModelState } state
   * @param { string } data
   */
  [DELETE_MEASURE](state, {data}) {
    const newData = {...state.sunModel.originalData};
    newData.facts = newData.facts.map((dimension) => {
      dimension.measures = dimension.measures.filter((measure) => measure.uuid !== data.uuid);
      return dimension;
    });

    state.sunModel.originalData = newData;
  },

  /**
   * @param { SunModelState } state
   * @param { string } linkId
   */
  [DELETE_LINK](state, linkId) {
    const newData = {...state.sunModel.originalData};
    newData.links = newData.links.filter((elem) => elem.linkId !== linkId);
    state.sunModel.originalData = newData;
  },


  /**
   * @param { SunModelState } state
   * @param { string } data
   */
  [SET_CONFIRM_MODAL](state, {data}) {
    state.sunModel.confirmModal = {...sunModel.confirmModal, ...data};
  },

  /**
   * @param { SunModelState } state
   * @param { string } data
   */
  [SET_REMOVE_ITEMS_MODAL](state, {data}) {
    state.sunModel.removeItemsModal = {...sunModel.removeItemsModal, ...data};
  },

  [LOAD_REMOVE_MODAL](state) {
    state.sunModel.removeItemsModal.loading = true;
  },

  /**
   * @param { SunModelState } state
   * @param { string } entityId
   */
  [DELETE_DIMENSION](state, entityId) {
    const newData = {...state.sunModel.originalData};
    newData.dimensions = newData.dimensions.filter((elem) => elem.entityId !== entityId);
    newData.links = newData.links.filter((elem) => elem.toEntityId !== entityId);
    state.sunModel.originalData = newData;

  },

  /**
   * @param { SunModelState } state
   * @param { string } entityId
   */
  [DELETE_FACT](state, entityId) {
    const newData = {...state.sunModel.originalData};
    newData.facts = newData.facts.filter((elem) => elem.entityId !== entityId);
    newData.links = newData.links.filter((elem) => elem.fromEntityId !== entityId);
    state.sunModel.originalData = newData;


  },
  [SET_AGGREGATION_TYPES](state, types) {
    state.attributesModal.aggregationTypes = [...types];
  },
  [SET_DATA_TYPES](state, types) {
    state.attributesModal.dataTypes = [...types];
  },
  [SHOW_SLIDER_MODAL](state, data) {
    state.sliderModal.show = true;
    state.sliderModal.data = {...data};
  },
  [HIDE_SLIDER_MODAL](state) {
    state.sliderModal.hide = false;
    state.sliderModal.data = {};
  },
  [SET_SHOW_HIDE_ATTRIBUTES](state, display) {
    state.sunModel.optionsFilter.displayAttributes = display;
  },
  [SET_SHOW_HIDE_MINOR_ELEMENTS](state, display) {
    state.sunModel.optionsFilter.displayMinorElements = display;
  },
  [SHOW_TAGS_MODAL](state) {
    state.tagsModal.show = true;
  },
  [HIDE_TAGS_MODAL](state) {
    state.tagsModal.show = false;
  },
  [SET_TAGS](state, tags) {
    state.tags.data = tags;
  },
  [SET_TAGS_LOADING](state, loading) {
    state.tags.loading = loading;
  },
};
